var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRhel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_147828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9814 10.8627C14.1515 10.8627 15.8457 10.6193 15.8457 9.22464C15.8456 9.11794 15.8362 9.01145 15.8176 8.90639L15.1249 5.87363C14.9658 5.20904 14.8254 4.90015 13.6554 4.31981C12.7474 3.85179 10.7724 3.0936 10.1827 3.0936C9.63041 3.0936 9.47128 3.79563 8.82542 3.79563C8.19827 3.79563 7.73962 3.27144 7.14991 3.27144C6.58829 3.27144 6.22323 3.65522 5.94242 4.44149C5.94242 4.44149 5.15615 6.6599 5.05319 6.98751C5.03772 7.04546 5.03141 7.10546 5.03447 7.16536C5.02511 8.02651 8.42292 10.8533 12.9814 10.8627ZM16.0235 9.79563C16.1827 10.5632 16.1827 10.6474 16.1827 10.741C16.1827 12.0515 14.7131 12.7816 12.7755 12.7816C8.39484 12.7816 4.56645 10.2168 4.56645 8.52261C4.56602 8.28764 4.61381 8.05507 4.70685 7.83931C3.13431 7.91419 1.09375 8.195 1.09375 9.99219C1.09375 12.9407 8.07659 16.5725 13.5992 16.5725C17.8395 16.5725 18.9065 14.6537 18.9065 13.1373C18.9065 11.9485 17.8769 10.6006 16.0235 9.79563Z",
    fill: "#EE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0235 9.79563C16.1826 10.5632 16.1826 10.6474 16.1826 10.741C16.1826 12.0515 14.7131 12.7816 12.7755 12.7816C8.3948 12.7816 4.56641 10.2168 4.56641 8.52262C4.56598 8.28764 4.61377 8.05508 4.70681 7.83931L5.05315 6.98752C5.03768 7.04546 5.03137 7.10547 5.03443 7.16537C5.03443 8.02652 8.43224 10.8534 12.9814 10.8534C14.1514 10.8534 15.8457 10.61 15.8457 9.21529C15.8456 9.10859 15.8362 9.0021 15.8176 8.89703L16.0235 9.79563Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_147828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13.6661,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRhel);
export default __webpack_public_path__ + "static/media/ic-rhel.b5e3829c512f91a730655e87c824a1cc.svg";
export { ForwardRef as ReactComponent };